import React from "react";
import Moment from "react-moment";
import { Link, NavLink } from "react-router-dom";
import { FORMAT_DATE_MOMENT, FORMAT_DATE_PICKER, STATUS_ENTRIES, TYPE_ENTRIES } from "../../../../api/constant";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "./entryIndex.css";
import LineTitle from "../../../app/atoms/LineTitle";
import StatusEntry from "../form/StatusEntry";
import { useAuth } from "../../../../context/security/AuthProvider";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faSave } from "@fortawesome/free-solid-svg-icons";
import {
  useActionsEntries,
  useEntries,
  useDispatchEntryIndex,
} from "../../../../context/inventory/EntryIndexProvider";
import { types } from "../../../../reducers/inventory/entriesReducer";
import Pagination from "../../../app/atoms/Pagination";
import { pluckArrayObject } from "../../../../utilities/math.utilities";
const EntryIndex = () => {
  const state = useAuth();
  const dispatch = useDispatchEntryIndex();

  const { warehouses } = state.user;
  const {
    entries: { elements: listEntries, rows, filter },
  } = useEntries();
  const actions = useActionsEntries();
  const { warehouse_id, page, limit, status_ids, types_detail, created_at, date_movement, order_number, nit, provider } = filter;
  const setInput = (e) => {
    dispatch({
      type: types.SET_FILTER_ENTRY,
      payload: { field: [e.target.name], value: e.target.value },
    })
  }
  return (
    <div className="container">
      <LineTitle title={"Lista de entradas"} />
      <div style={{ marginTop: "23px" }} className="flex justify-betwen">
        <div className="container-filter-movementes"><div className="form-group">
          <label>Almacén</label>
          <Select
            value={warehouses.filter((w) => w.id === warehouse_id)}
            placeholder="Almacén"
            getOptionLabel={(option) => option.code + " - " + option.name}
            getOptionValue={(option) => option.id}
            options={warehouses}
            className="entry-index-select"
            styles={customStyles}
            isClearable
            onChange={(e) =>
              dispatch({
                type: types.SET_FILTER_ENTRY,
                payload: { field: "warehouse_id", value: e ? e.id : null },
              })
            }
          />
        </div>
          <div className="form-group date-input">
            <label>Fecha entrega</label>
            <DatePicker
              selected={date_movement}
              className="form-control "
              isClearable={true}
              onChange={(date) =>
                dispatch({
                  type: types.SET_FILTER_ENTRY,
                  payload: { field: "date_movement", value: date },
                })
              }
              dateFormat={FORMAT_DATE_PICKER}
            />
          </div>
          <div className="form-group date-input">
            <label>Proveedor</label>
            <input value={provider} onChange={e => setInput(e)} type="text" name="provider" className="form-control" />
          </div>
          <div className="form-group date-input">
            <label>Nit</label>
            <input value={nit} onChange={e => setInput(e)} type="text" name="nit" className="form-control" />
          </div>
          <div>
            <label>Tipo</label>
            <Select
              placeholder="Tipo"
              value={TYPE_ENTRIES.filter((w) => types_detail.includes(w.code))}
              onChange={(e) =>
                dispatch({
                  type: types.SET_FILTER_ENTRY,
                  payload: {
                    field: "types_detail",
                    value: pluckArrayObject(e, "code"),
                  },
                })

              }
              isClearable
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.code}
              options={TYPE_ENTRIES}
              isMulti
              styles={customStyles}
            />
          </div>
          <div className="form-group date-input">
            <label>No Doc</label>
            <input value={order_number} onChange={e => setInput(e)} type="text" name="order_number" className="form-control" />
          </div>
          <div className="form-group date-input">
            <label>Fecha doc</label>
            <DatePicker
              selected={created_at}
              className="form-control "
              isClearable={true}
              onChange={(date) =>
                dispatch({
                  type: types.SET_FILTER_ENTRY,
                  payload: { field: "created_at", value: date },
                })
              }
              dateFormat={FORMAT_DATE_PICKER}
            />
          </div>
          <div>
            <label>Estado</label>
            <Select
              placeholder="Estado"
              value={STATUS_ENTRIES.filter((w) => status_ids.includes(w.code))}
              onChange={(e) =>
                dispatch({
                  type: types.SET_FILTER_ENTRY,
                  payload: {
                    field: "status_ids",
                    value: pluckArrayObject(e, "code"),
                  },
                })
              }
              getOptionLabel={(option) => option.name}
              getOptionValue={(option) => option.code}
              options={STATUS_ENTRIES}
              isMulti
              styles={customStyles}
            />
          </div>
        </div>

        <div>
          {" "}
          <label></label>
          <NavLink to={"/inventory/entry"}>
            <div className="btn-default flex">
              <FontAwesomeIcon icon={faBox} />
              &nbsp;
              <span>Nueva</span>
            </div>
          </NavLink>
        </div>
      </div>
      <table className="table table-default-app">
        <thead className="thead-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Fecha entrega</th>
            <th scope="col">Proveedor</th>
            <th scope="col">Nit</th>
            <th scope="col">Tipo de doc.</th>
            <th scope="col">No. documento</th>
            <th scope="col">Fecha documento</th>
            <th scope="col">Total referencias</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>
        <tbody>
          {listEntries.map((entry) => {
            return (
              <tr onClick={() => actions.loadEntry(entry.id)} className="cursor-pointer td-hoverme" key={entry.id}>
                <td>{entry.id}</td>
                <td>
                  <Moment format={FORMAT_DATE_MOMENT}>
                    {entry.created_at}
                  </Moment>
                </td>
                <td>{entry.provider}</td>
                <td>{entry.nit}</td>
                <td>
                  {TYPE_ENTRIES.filter((t) => t.code === entry.type)[0].name}
                </td>
                <td>{entry.order_number}</td>
                <td>
                  <Moment format={FORMAT_DATE_MOMENT}>
                    {entry.date_movement}
                  </Moment>
                </td>
                <td>{entry.distinct_references} / {entry.quantity_references}</td>
                <td>
                  <StatusEntry status_id={entry.status_id} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex justify-end" style={{ marginBottom: "3rem" }}>
        <Pagination
          onChangepage={(e) =>
            dispatch({
              type: types.SET_FILTER_ENTRY,
              payload: { field: "page", value: e },
            })
          }
          page={page}
          limit={limit}
          rows={rows}
        />
      </div>
    </div>
  );
};
export default EntryIndex;
